import { render } from "./VerzeichnisBruder.vue?vue&type=template&id=c7ec597a"
import script from "./VerzeichnisBruder.vue?vue&type=script&lang=js"
export * from "./VerzeichnisBruder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__